import { supabase } from '../../config/supabaseClient';
import { ENV } from '../../config/env';

export interface PortfolioProjectRow {
  id: string;
  organization_id: string;
  name: string;
  status: string;
  completion_percentage: number;
  total_tasks: number;
  completed_tasks: number;
  blocked_tasks: number;
  overdue_tasks: number;
  total_hours_logged: number;
  active_members: number;
}

export interface PortfolioReport {
  stats: {
    total_projects: number;
    active_projects: number;
    completed_projects: number;
    projects_at_risk: number;
    total_tasks: number;
    completed_tasks: number;
    blocked_tasks: number;
    overdue_tasks: number;
    total_hours_logged: number;
  };
  projects: PortfolioProjectRow[];
  at_risk_projects: PortfolioProjectRow[];
}

async function getToken(): Promise<string> {
  const { data: { session } } = await supabase.auth.getSession();
  if (!session) throw new Error('Not authenticated');
  return session.access_token;
}

const API_BASE_URL = ENV.API_URL;

export const portfolioService = {
  async getPortfolio(organizationId: string): Promise<{ data: PortfolioReport | null; error: any }> {
    try {
      const token = await getToken();
      const queryParams = new URLSearchParams({ organization_id: organizationId });

      const response = await fetch(`${API_BASE_URL}/api/project-management/reports/portfolio?${queryParams.toString()}`, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      });

      const result = await response.json();
      if (!response.ok) {
        return { data: null, error: result?.error || 'Failed to fetch portfolio report' };
      }

      return { data: (result.data || null) as PortfolioReport | null, error: null };
    } catch (e: any) {
      return { data: null, error: e?.message || 'Network error' };
    }
  },
};
